import makeStyles from '@material-ui/core/styles/makeStyles';
import { reduce } from 'lodash';

import { SIZED_CELL_CLASS, ROWHEIGHT, INNER_CELL_VALUE_CLASS, ROWCLASS, ROWSIZE } from './DataTableConstants';

export default makeStyles((theme) => ({
    root: {
        padding: 0,
        margin: 0,

        '&.padded': {
            padding: theme.spacing(2),
        },

        '&.full-height': {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.flexDirectionColumn,
            ...theme.mixins.flex.grow(1),
            ...theme.mixins.flex.shrink(1),
        },
    },

    dataTableRoot: {
        width: '100%',

        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionColumn,
        ...theme.mixins.flex.grow(0),
        ...theme.mixins.flex.shrink(0),

        '&.full-height': {
            ...theme.mixins.flex.grow(1),
            ...theme.mixins.flex.shrink(1),
        },

        ...buildSizedRowClasses(theme),

        [`& .${INNER_CELL_VALUE_CLASS}`]: {
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            cursor: 'default',

            '& .MuiTableSortLabel-root': {
                textOverflow: 'ellipsis',
            },

            '& .display-inline': {
                display: 'inline',
            },
        },
    },

    loadingContainer: {
        position: 'relative',
        zIndex: 1,
        height: 0,
    },

    loader: {
        height: '1px',
        overflow: 'hidden',
        top: '1px',
    },
}));

export const useLoaderStyles = makeStyles((theme) => ({
    root: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        ...theme.mixins.flex.alignItemsCenter,
    },

    textContainer: {
        marginLeft: theme.spacing(1),
    },
}));

function buildSizedRowCSSSelector(rowSize) {
    const rowSizeClassName = ROWCLASS[rowSize];

    return `&.${rowSizeClassName} .${SIZED_CELL_CLASS}`;
}

function buildSizedRowStyle(rowSize, theme) {
    const height = ROWHEIGHT[rowSize];
    const heightPx = `${height}px`;

    return {
        padding: theme.spacing(0, 1),
        height: heightPx,
        lineHeight: heightPx,

        '&.disable-padding': {
            padding: 0,
        },
    };
}

function buildSizedRowClasses(theme) {
    return reduce(
        ROWSIZE,
        (classes, rowSize) => {
            const selector = buildSizedRowCSSSelector(rowSize);
            const styles = buildSizedRowStyle(rowSize, theme);

            return { ...classes, [selector]: styles };
        },
        {}
    );
}
